import { entityType } from "./module";
import {createDeleteMethod, createPostMethod, createPutMethod} from "reactcoregk/store/actions";
import {getDefaultApiHandler, getDefaultHeaders} from "../../helpers/utils";
import ApiHandler from "reactcoregk/models/apiHandler";
export const api = () => new ApiHandler(false, false, getDefaultHeaders())

export const createTactic = (payload) => createPostMethod(entityType, payload, api());
export const updateTactic = (payload) =>  createPutMethod(entityType, payload, api())
export const deleteTactic = (payload) => createDeleteMethod(entityType, payload, getDefaultApiHandler())
